import type { AxiosInstance, AxiosResponse } from 'axios';

import type { Event } from '@/models/event';
import type { RootResponse } from '@/models/rootResponse';

export type GetEvents = {
   page: number;
   search?: string;
   isFetchOnlyMyEvents: boolean;
   userId: string;
   surveyId?: string;
   eventId?: string;
};

class SessionService {
   private provider: AxiosInstance;

   constructor(provider: AxiosInstance) {
      this.provider = provider;
   }

   async getEvents({
      search = '',
      isFetchOnlyMyEvents,
      userId,
   }: GetEvents): Promise<RootResponse<Event[]>> {
      /* TODO: keep for backend info for the moment
    const body = bodySearchEvent(
      surveyId,
      eventId,
      search,
      userId,
      isFetchOnlyMyEvents,
    ); */

      const response: AxiosResponse<RootResponse<Event[]>> =
         await this.provider.post(`/rest/events/search`, {
            search: {
               filters: [
                  {
                     nested: [
                        {
                           type: 'or',
                           field: 'label',
                           operator: 'like',
                           value: `%${search}%`,
                        },
                        {
                           type: 'or',
                           field: 'sessions.label',
                           operator: 'like',
                           value: `%${search}%`,
                        },
                     ],
                  },
                  {
                     field: 'status.label',
                     operator: '!=',
                     value: 'closed',
                  },

                  ...(isFetchOnlyMyEvents
                     ? [
                          {
                             field: 'creator.id',
                             operator: '=',
                             value: userId,
                          },
                       ]
                     : []),
               ],
               includes: [
                  {
                     relation: 'sessions',
                  },
               ],
            },
         });
      return response.data;
   }

   async attachSession(surveyId: string, ids: string[]): Promise<void> {
      await this.provider.post(`/surveys/${surveyId}/sessions/attach`, {
         resources: ids,
         app_from: 'questionnaire',
      });
   }

   async syncSession(surveyId: string, ids: string[]): Promise<void> {
      await this.provider.patch(`/surveys/${surveyId}/sessions/sync`, {
         resources: ids,
         app_from: 'questionnaire',
      });
   }
}

export default SessionService;
